import { useEffect, useState } from "react";

/**
 * SSR-safe mobile detection. Defaults to `false` on the server so SSR markup
 * matches the desktop render; flips to true on the client after mount when the
 * viewport is narrow (or the device reports low concurrency / coarse pointer).
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const coarse = window.matchMedia("(pointer: coarse)");
    const lowCpu =
      typeof navigator !== "undefined" &&
      typeof navigator.hardwareConcurrency === "number" &&
      navigator.hardwareConcurrency > 0 &&
      navigator.hardwareConcurrency <= 4;

    const update = () => setIsMobile(mql.matches || (coarse.matches && lowCpu));
    update();
    mql.addEventListener("change", update);
    coarse.addEventListener("change", update);
    return () => {
      mql.removeEventListener("change", update);
      coarse.removeEventListener("change", update);
    };
  }, [breakpoint]);

  return isMobile;
}
